import { useCallback } from 'react';

import { useI18n } from '@change-corgi/core/react/i18n';

import { TASKS_CONFIGS } from '../../../../constants';
import type { Task } from '../../../../types';

export function useTitle() {
	const { translate } = useI18n();

	return useCallback(
		({ name }: { name: Task['name']; metadata: Task['metadata'] }) => {
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			const key = name as keyof typeof TASKS_CONFIGS;
			const { title } = TASKS_CONFIGS[key];

			return translate(title);
		},
		[translate],
	);
}
